import React from 'react';
import style from './style.module.css';
import { useSelector } from 'react-redux';
import { Col, Row, Statistic, Spin } from 'antd';

const StageStats = ({ userView }) => {
  const projectStats = useSelector((state) => state.projectStats);

  if (projectStats.isLoading)
    return (
      <div className={style.statsWrapper}>
        <Spin />
      </div>
    );

  return (
    <>
      {!userView && (
        <div className={style.statsWrapper}>
          <Row gutter={16}>
            <Col span={6}>
              <Statistic
                title="Aktualny zysk"
                value={projectStats.actualIncome}
                precision={2}
                suffix="zł"
              />
            </Col>
            <Col span={6}>
              <Statistic
                title="Całkowity koszt zespołu"
                value={projectStats.totalCost}
                precision={2}
                suffix="zł"
              />
            </Col>
          </Row>
        </div>
      )}
      <div className={style.statsWrapper}>
        <Row gutter={16}>
          <Col span={6}>
            <Statistic
              title="Suma godzin"
              value={projectStats.spentHours}
              suffix="h"
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default StageStats;
